import React, { useState, useEffect, useCallback } from "react";
import Sidebar from "../../layout/Sidebar";
import Header from "../../layout/Header";
import Footer from "../../layout/Footer";
import AdminDataTable from "../../components/common/AdminDataTable";
import { feedbackColumns } from "../../tables/feedbackColumns";

export default function Feedback() {
  const PAGE_SIZE = 10;
  const API_URL = process.env.REACT_APP_BASE_URL_API || "";
  const token = localStorage.getItem("adminToken");

  // State
  const [feedbacks, setFeedbacks] = useState([]);
  const [listLoading, setListLoading] = useState(false);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(PAGE_SIZE);
  const [totalPages, setTotalPages] = useState(1);
  const [sortBy, setSortBy] = useState("createdAt");
  const [sortOrder, setSortOrder] = useState("desc");

  // Fetch feedback list from API
  const fetchFeedbacks = useCallback(async () => {
    try {
      setListLoading(true);
      const query = new URLSearchParams({
        page,
        pageSize,
        sortBy,
        sortOrder,
      });

      const res = await fetch(`${API_URL}/api/admin/feedback-list?${query.toString()}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const result = await res.json();

      if (result.success) {
        setFeedbacks(result.data || []);
        setTotalPages(Math.ceil(result.totalCount / pageSize));
      } else {
        setFeedbacks([]);
        setTotalPages(1);
      }
    } catch (err) {
      console.error("Fetch Feedbacks Error:", err);
      setFeedbacks([]);
      setTotalPages(1);
    } finally {
      setListLoading(false);
    }
  }, [API_URL, token, page, pageSize, sortBy, sortOrder]);

  useEffect(() => {
    fetchFeedbacks();
  }, [fetchFeedbacks]);

  // Edit and Delete handlers
  const handleEdit = (feedback) => {
    alert("Edit feedback: " + feedback._id);
    // implement edit logic if needed
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this feedback?")) return;
    try {
      const res = await fetch(`${API_URL}/api/admin/feedback-list/delete/${id}`, {
        method: "DELETE",
        headers: { Authorization: `Bearer ${token}` },
      });
      const result = await res.json();
      if (result.success) {
        alert("Feedback deleted successfully!");
        fetchFeedbacks();
      } else {
        alert(result.message || "Failed to delete feedback.");
      }
    } catch (err) {
      console.error("Delete Feedback Error:", err);
      alert("Server error.");
    }
  };

   

  const columns = feedbackColumns(handleEdit, handleDelete, PAGE_SIZE);

  return (
    <div className="container body">
      <div className="main_container">
        <Sidebar />
        <Header pageTitle="Feedback" />

        <div className="right_col" role="main">
          

          {/* Feedback List */}
          <div className="x_panel">
            <div className="x_title">
              <h2>List</h2>
              <ul className="nav navbar-right panel_toolbox" style={{ minWidth: 1 }}>
                <li>
                  <a className="collapse-link">
                    <i className="fa fa-chevron-up" />
                  </a>
                </li>
              </ul>
              <div className="clearfix" />
            </div>

            <AdminDataTable
              columns={columns}
              data={feedbacks}
              loading={listLoading}
              page={page}
              pageSize={pageSize}
              totalPages={totalPages}
              onPageChange={setPage}
              onPageSizeChange={(size) => {
                setPageSize(size);
                setPage(1);
              }}
              sortBy={sortBy}
              setSortBy={setSortBy}
              sortOrder={sortOrder}
              setSortOrder={setSortOrder}
            />
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
}
